module.exports = __webpack_public_path__ + "img/grey.7ef66bf.svg";